import { Link } from 'react-router-dom';
import { liveMatches } from '@/mocks/data';

export default function LiveMatches() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              热门赛事
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时赔率更新，把握最佳投注时机</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-1.5 text-sm text-primary-500 font-medium">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              进行中 {liveMatches.filter((m) => m.status === 'live').length} 场
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {liveMatches.slice(0, 8).map((match) => (
            <Link
              key={match.id}
              to={`/category/${match.category}`}
              className="block bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-300 transition-all cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs text-foreground-500 font-medium">{match.league}</span>
                {match.status === 'live' ? (
                  <span className="flex items-center gap-1 text-xs text-primary-500 font-semibold">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
                    直播中
                  </span>
                ) : match.status === 'upcoming' ? (
                  <span className="text-xs text-foreground-400">{match.time}</span>
                ) : (
                  <span className="text-xs text-foreground-400">已结束</span>
                )}
              </div>

              <div className="flex items-center justify-between mb-3">
                <div className="flex-1 text-center">
                  <p className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{match.homeTeam}</p>
                </div>
                {match.score && (
                  <div className="px-3">
                    <span className="text-lg font-bold text-foreground-900">{match.score}</span>
                  </div>
                )}
                <div className="flex-1 text-center">
                  <p className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{match.awayTeam}</p>
                </div>
              </div>

              <div className="flex items-center gap-2 pt-3 border-t border-background-200/60">
                <div className="flex-1 text-center py-1.5 rounded bg-background-100 hover:bg-primary-100 transition-colors cursor-pointer">
                  <span className="text-xs font-semibold text-foreground-700">{match.homeOdds}</span>
                </div>
                {match.drawOdds !== '-' && (
                  <div className="flex-1 text-center py-1.5 rounded bg-background-100 hover:bg-primary-100 transition-colors cursor-pointer">
                    <span className="text-xs font-semibold text-foreground-700">{match.drawOdds}</span>
                  </div>
                )}
                <div className="flex-1 text-center py-1.5 rounded bg-background-100 hover:bg-primary-100 transition-colors cursor-pointer">
                  <span className="text-xs font-semibold text-foreground-700">{match.awayOdds}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/football"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 border border-primary-300 text-primary-600 rounded-full text-sm hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            查看全部赛事
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}